var map = {
	"./cs.json": 101,
	"./de.json": 102,
	"./en.json": 103,
	"./hu.json": 104,
	"./pl.json": 105,
	"./pt.json": 106,
	"./sk.json": 107,
	"./sv.json": 108
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;



//////////////////
// WEBPACK FOOTER
// ./lang ^\.\/.*\.json$
// module id = 171
// module chunks = 3